import UploadService from 'services/upload-service';

import { processExternalImage } from 'helpers/asset-utils';
import { createPhotoForProject } from 'helpers/photos';

const uploadRequestAndCreateProjectPhoto = async (
  file: File,
  projectId: number,
) => {
  const uploadService = new UploadService();

  const { dataURL } = await processExternalImage({ file });

  let identifier;
  if (dataURL) {
    identifier = await uploadService.securelyUploadDataURLToS3(dataURL);
  } else {
    identifier = await uploadService.securelyUploadFileToS3(file);
  }

  const response = await createPhotoForProject(projectId, {
    uploadRequest: identifier,
  });

  return response;
};

export { uploadRequestAndCreateProjectPhoto };
